import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../local-storage.service';
import { TranslationService } from '../translation.service';

interface VersionEntry {
  version: string;
  type: string;
  date: string | null;
  summary: string;
  summary_fr?: string;
  summary_es?: string;
  notes: string[];
}

@Component({
    selector: 'app-version-history',
    templateUrl: './version-history.component.html',
    styleUrls: ['./version-history.component.css'],
    standalone: false
})
export class VersionHistoryComponent implements OnInit {
  entries: VersionEntry[] = [];
  loading = true;
  error = '';
  selectedLanguage: string = 'en';
  private langSub?: Subscription;

  @Output() close = new EventEmitter<void>();

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private translationService: TranslationService
  ) {}

  /** Load version history from assets/version-log.json on init. */
  ngOnInit(): void {
    this.setLanguage();
    this.langSub = this.translationService.changeLangage$.subscribe(() => this.setLanguage());

    this.http.get<VersionEntry[]>('assets/version-log.json').subscribe({
      next: (data) => {
        this.entries = data;
        this.loading = false;
      },
      error: () => {
        this.error = 'Unable to load version history.';
        this.loading = false;
      },
    });
  }

  /** Pick localized summary based on selected language. */
  summaryFor(entry: VersionEntry): string {
    switch (this.selectedLanguage) {
      case 'fr':
        return entry.summary_fr || entry.summary;
      case 'es':
        return entry.summary_es || entry.summary;
      default:
        return entry.summary;
    }
  }

  /** Notify parent to close the panel. */
  onClose(): void {
    this.close.emit();
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  private setLanguage(): void {
    this.selectedLanguage = this.localStorageService.getItem('language') || 'fr';
  }
}
